<template>
  <div class="gas-content">
    <div class="gas-left" :class="{'gas-expand': !expandState}">
      <div class="gas-title">{{ $t('useGas.index.824943-0') }}</div>
      <Menu theme="dark" :active-name="activeName" @on-select="onSelect" id="menu-left">
        <div v-for="item in menuList" :key="item.router">
          <router-link :to="{ name: item.router }">
            <MenuItem :name="item.router">
              <Icon :type="item.icon" />{{ item.title }}
            </MenuItem>
          </router-link>
        </div>
      </Menu>
    </div>
    <div class="gas-right" :class="{'gas-right-select': !expandState}">
      <div class="gas-head">
        <div class="gas-head-left">
          <div class="left-icon" @click="reorderClick"><Icon type="md-reorder" /></div>
          <div>{{activeTitle}}</div>
        </div>
        <div class="gas-head-rigth">
          <div class="icon" @click="goAlarm"><Icon type="md-notifications-outline" /><div class="count" v-if="count">{{count > 99 ? '99+' : count}}</div></div>
          <div class="icon" @click="backClick"><Icon type="md-log-out" /></div>
        </div>
      </div>
      <div class="gas-body">
        <Card class="gas-card" dis-hover>
          <router-view @on-change="onChange"/>
        </Card>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../api/request.js";
import Cookies from "js-cookie";
const URL = {
  GetCurrRoomAbDevices: "api/CommElecDevice/GetCurrRoomAbDevices" // 告警设备
};

export default {
  data() {
    return {
      expandState: true,
      activeName: "",
      activeTitle: this.$t('useGas.index.824943-1'),
      count: 0,

      menuList: [
        {
          router: "map_home",
          icon: "md-home",
          title: this.$t('useGas.index.824943-2')
        },
        {
          router: "area",
          icon: "md-map",
          title: this.$t('useGas.index.824943-1')
        },
        // {
        //   router: "userType",
        //   icon: "ios-man",
        //   title: "用户类型管理"
        // },
        {
          router: "user",
          icon: "md-people",
          title: this.$t('useGas.index.824943-3')
        },
        {
          router: "device",
          icon: "md-filing",
          title: this.$t('useGas.index.824943-4')
        },
        {
          router: "alert",
          icon: "md-notifications",
          title: this.$t('useGas.index.824943-5')
        }
      ]
    };
  },
  computed: {
      UseGasState() {
        let _this = this;
        return _this.$store.getters.getUseGasState;
      }
    },
    watch: {
      UseGasState(value) {
        let _this = this;
        if (value) {
          _this.GetCurrRoomAbDevices()
        }
      }
    },
  mounted() {
    this.activeName = this.$route.name;
    const menuItem = this.menuList.find(item => item.router === this.$route.name)
    if (menuItem) {
      this.activeTitle = this.menuList.find(item => item.router === this.$route.name).title
    } else {
      this.activeTitle = this.$t('useGas.index.824943-6')
    }
    this.GetCurrRoomAbDevices();
    if (this.$driver.isActivated) {
      let steps = [
        {
          element: "#menu-left",
          popover: {
            title: this.$t('useGas.index.824943-7'),
            description: this.$t('useGas.index.824943-8'),
            position: "right",
            className: 'robotLeft'
          }
        },
      ]
      this.$nextTick(() => {
        this.$driver.defineSteps(steps);
        this.$driver.start();
      })
    }
  },
  methods: {
    reorderClick() {
      this.expandState = !this.expandState
    },
    onChange() {
      console.log(1213);
      this.activeName = "device"
    },
    onSelect(name) {
      this.activeTitle = this.menuList.find(item => item.router === name).title
    },
    // 告警设备
    goAlarm() {
      if (this.$route.name !== 'alarm') {
        this.activeTitle = this.$t('useGas.index.824943-6')
        this.activeName = 'alarm'
        this.$router.push({
          name: 'alarm'
        });
      }

    },
    // 返回
    backClick() {
      this.$router.push({
        name: 'bigScreen'
      });
    },
    // 获取告警设备列表
    GetCurrRoomAbDevices() {
      const { GroupCode, CompanyCode, DepartmentCode, IsAdmin } = JSON.parse(
        Cookies.get("AdminData")
      );
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "get",
          url: `${URL.GetCurrRoomAbDevices}?groupCode=${GroupCode}&companyCode=${CompanyCode}&departmentCode=${DepartmentCode}&isAdmin=${IsAdmin}&deviceType=qg&pageIndex=1&pageSize=1000`,
          data: {},
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token") ? Cookies.get("Token") : ""
          }
        },
        "yhj"
      ).then(res => {
        this.count = res.TotalCount || 0
        this.$store.dispatch("setUseGasState", false);
      });
    },
  }
};
</script>

<style scoped>
.gas-content {
  width: 100vw;
  height: 100vh;
  background-color: #eff3f6;
  display: flex;
}
.gas-left {
  width: 240px;
  height: 100%;
  background-color: #515a6e;
  overflow: hidden;
}
.gas-expand {
  width: 70px;
}
.gas-title {
  width: 100%;
  margin:15px 0;
  text-align: center;
  font-size: 18px;
  font-weight: bold;
  color: #fff;
}
.gas-right {
  width: calc(100% - 240px);
  height: 100%;
}
.gas-right-select {
  width: calc(100% - 70px);
}
.gas-head {
  width: 100%;
  height: 60px;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.gas-head-left {
  margin-left: 20px;
  line-height: 60px;
  font-size: 14px;
  font-weight: bold;
  display: flex;
  align-items: center;
}
.gas-head-rigth {

  display: flex;
  align-items: center;

}
.icon {
    margin-right: 20px;
    font-size: 25px;
    position: relative;
    padding: 5px;
  }
.count {
  width: 15px;
  height: 15px;
  position: absolute;
  right: 0;
  top: 5px;
  text-align: center;
  line-height: 15px;
  font-size: 12px;
  background-color: rgb(235, 57, 65);
  border-radius: 50%;
  color: #fff;
}
.gas-body {
  width: 100%;
  height: calc(100vh - 60px);
  overflow: hidden;
}
.gas-card {
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  margin: 10px;
}
.gas-content >>> .ivu-card-body {
  height: 100%;
}
.left-icon {
  width: 30px;
  height: 30px;
  text-align: center;
  line-height: 26px;
  font-size: 20px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/useGas/index.vue